module.exports = __webpack_public_path__ + "static/media/Aipom_gaussian2.63af2ddc.png";